export default function Footer({ disclaimer }) {    
    if (!disclaimer) {
        return <div/>;
    }

    return (
        <div className="test__footer">
            {disclaimer && (
                <p className="test__disclaimer"><strong className="test__bold">Disclaimer:</strong> {disclaimer}</p>
            )}
        </div>
    );
}